var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeNinjaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2392_15452)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 64,
    fill: "url(#paint0_linear_2392_15452)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 224,
    height: 224
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12px)",
      clipPath: "url(#bgblur_0_2392_15452_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 24,
    cx: 112,
    cy: 112,
    r: 72,
    fill: "white",
    fillOpacity: 0.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2392_15452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 89.9999C102.856 89.9999 94.675 92.5608 89.3125 97.6827C89.0719 97.3733 88.8656 97.0983 88.7453 96.8921C87.9375 95.603 86.9922 94.0905 86.3047 92.5608C86.1844 92.2858 86.0641 92.0108 85.9781 91.753C86.5797 91.9077 87.2844 92.0108 88.0578 91.9593C88.7797 91.9077 89.5703 91.6671 90.275 91.1343C90.9453 90.6358 91.3406 90.0343 91.5641 89.553C91.9766 88.6765 92.0109 87.7999 92.0109 87.2671C92.0109 86.1155 91.7187 84.7577 91.4094 83.5202C90.7562 80.9765 89.45 71.764 88.6422 69.8218L82.8328 78.7937C83.4859 80.3749 84.3281 82.6437 84.9125 84.6546C84.775 84.6202 84.6375 84.603 84.4828 84.5858C83.95 84.5171 83.1422 84.4999 82.2484 84.8265C80.0828 85.6171 79.3781 87.5249 79.1547 88.7108C78.7078 91.1515 79.55 93.6265 80.3578 95.4312C81.2172 97.339 82.0766 98.0608 82.0766 98.0608L84.4312 100.776L85.8578 102.048C84.7234 103.922 83.864 106.001 83.3312 108.305C82.1281 107.686 80.7187 106.964 79.4812 106.156C79.2578 106.001 79.0344 105.864 78.8453 105.726C79.3265 105.641 79.8765 105.469 80.3922 105.194C80.8734 104.919 81.3031 104.506 81.5266 103.922C81.75 103.372 81.7156 102.822 81.6297 102.426C81.475 101.705 81.0797 101.086 80.8047 100.725C80.2203 99.9343 79.3609 99.1093 78.5359 98.3874C76.8172 96.8749 71.3516 91.0483 69.8391 89.9999L70.2344 97.9577C71.4719 98.8343 73.1734 100.089 74.5656 101.258C74.4625 101.275 74.3422 101.309 74.239 101.344C73.8266 101.481 73.2594 101.722 72.8125 102.22C71.6953 103.441 72.1422 104.97 72.5891 105.847C73.4828 107.651 75.2875 109.061 76.7656 110.023C78.2953 111.037 79.2578 111.261 79.2578 111.261L82.2484 112.344L82.7812 112.481C82.7469 113.014 82.6953 113.53 82.6953 114.097C82.6953 130.167 95.8266 146.839 112.034 146.839C128.242 146.839 141.373 130.167 141.373 114.097C141.373 98.0265 128.242 89.9999 112.034 89.9999H112Z",
    fill: "url(#paint1_linear_2392_15452)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M91.6156 133.089C87.9375 127.881 85.7375 121.522 85.7375 115.248C85.7375 100.725 97.5625 93.4717 112.138 93.4717C126.713 93.4717 129.239 96.2904 133.983 101.928C129.48 95.2076 120.817 91.8389 110.883 91.8389C96.2906 91.8389 84.4828 99.092 84.4828 113.615C84.4828 128.139 87.1813 127.623 91.5984 133.089H91.6156Z",
    fill: "#E8EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.286 114.887C136.286 125.389 124.358 135.839 112 135.839C99.6422 135.839 87.7141 125.389 87.7141 114.887C87.7141 104.386 99.6422 106.723 112 106.723C124.358 106.723 136.286 104.386 136.286 114.887Z",
    fill: "url(#paint2_linear_2392_15452)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.869 115.523C132.9 118.136 130.734 121.264 127.039 122.501C123.344 123.739 119.511 122.605 118.48 119.992C117.448 117.38 119.528 116.28 123.223 115.059C126.919 113.822 130.837 112.911 131.869 115.54V115.523ZM92.1312 115.523C91.1 118.136 93.2656 121.264 96.9609 122.501C100.656 123.739 104.489 122.605 105.52 119.992C106.552 117.38 104.472 116.28 100.777 115.059C97.0812 113.822 93.1625 112.911 92.1312 115.54V115.523Z",
    fill: "url(#paint3_linear_2392_15452)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2392_15452",
    x: 0,
    y: 0,
    width: 224,
    height: 224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24,
    result: "effect1_foregroundBlur_2392_15452"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2392_15452_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 72
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2392_15452",
    x1: 48,
    y1: 112,
    x2: 176,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#005CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2392_15452",
    x1: 134.825,
    y1: 139.001,
    x2: 78.3984,
    y2: 82.5749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#61696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8E9496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBFC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2392_15452",
    x1: 110.058,
    y1: 105.761,
    x2: 116.314,
    y2: 135.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7E9EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919EA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2392_15452",
    x1: 92.2347,
    y1: 114.525,
    x2: 131.385,
    y2: 121.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A74FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2392_15452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(68 68)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeNinjaIcon);
export default __webpack_public_path__ + "static/media/welcomeNinjaIcon.6bf47f586c1489b9afead677802ba222.svg";
export { ForwardRef as ReactComponent };